import { render } from "./ReadMoreText.vue?vue&type=template&id=0c8f8522"
import script from "./ReadMoreText.vue?vue&type=script&lang=js"
export * from "./ReadMoreText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/ReadMoreText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c8f8522"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c8f8522', __exports__)) {
    api.reload('0c8f8522', __exports__)
  }
  
  module.hot.accept("./ReadMoreText.vue?vue&type=template&id=0c8f8522", () => {
    api.rerender('0c8f8522', render)
  })

}


export default __exports__